/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import ProgressBar from 'components/shared/progressbar/progressbar';
import Question from 'components/content/shared/questionset/shared/question/question_container';
import Answer from 'components/content/shared/questionset/shared/answer/answer_container';
// import QuestionResult from 'components/shared/questionset/shared/result/result_container';
// import RewardsMessage from 'components/shared/questionset/shared/rewards/rewards_container';
import UserMessage from 'components/shared/usermessage/usermessage';
import RewardsFeedback from 'components/shared/rewardsfeedback/rewardsfeedback_container';
import Skip from 'components/shared/skip/skip_container';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/content/shared/questionset/image2/image2_styles';
import { createStyles } from 'utils/styles';
const { classes } = createStyles(styles);



/* ========== ~~~~~~~~~~ IMAGE 2 SET ~~~~~~~~~~ ========== */
const Image2Set = (passedProps) => {
    let props = passedProps.data;
    const resultClass = props.frameStatus[props.frame]['state'];
    // resultClass = props.frameStatus[props.frame].includes('rewards') ? 'rewards' : resultClass;
    return(
        <div className={`${classes.typeset} type-${props.frameData.question.type} parentContentType-${passedProps.contentType} ${resultClass}`}>
            <div className={`${classes.resultelements} resultelements`}>
                {/*<QuestionResult contentId={props.contentId} frame={props.frame} />*/}
                <ProgressBar type={`result`} duration={props.showResultForXSeconds} fillingDelay={2400} direction={`leftToRight`} isActive={resultClass === 'result'} shouldKillItself={false} />
                <UserMessage hasRewardsComponent={passedProps.hasRewardsComponent}>
                    <RewardsFeedback contentId={passedProps.data.contentId} frame={props.frame} />
                </UserMessage>
            </div>
            {props.showFrameForXSeconds != null ? <ProgressBar type={`frame`} duration={props.showFrameForXSeconds} fillingDelay={0} direction={`leftToRight`} isActive={props.showFrameForXSeconds != null} shouldKillItself={resultClass === 'clicked'}/> : null}
            <Question contentId={props.contentId} frameData={props.frameData} />
            <div className={`${classes.answerset} answerset answeramount-${props.frameData.answers.length}`}>
                <ul>
                    {props.frameData.answers.map(answer => <Answer type={props.frameData.question.type} answer={answer} predictionPercentage={passedProps.percentageAnsweredData[answer.id]} barCoefficient={passedProps.barCoefficient} contentId={props.contentId} frame={props.frame}/>)}
                </ul>
            </div>
            {/*<RewardsMessage contentId={passedProps.data.contentId} frame={props.frame} />*/}
        </div>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Image2Set;
